import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Cookie } from "lucide-react";
import { initGA } from "../lib/analytics";

const KEY = "cookie-consent";

export default function CookieBanner() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const v = localStorage.getItem(KEY);
    if (!v) setOpen(true);
  }, []);

  const decide = (value) => {
    localStorage.setItem(KEY, value);
    setOpen(false);
    if (value === "accepted") {
      initGA();
    }
  };

  if (!open) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-4 inset-x-4 md:inset-x-auto md:left-4 md:right-auto lg:max-w-md z-[60]"
    >
      <div className="bg-white border border-slate-200 rounded-xl shadow-xl p-5">
        <div className="flex items-start gap-3">
          <Cookie className="w-5 h-5 text-[#9C6644] mt-1" strokeWidth={1.5} />
          <div>
            <div className="font-display font-medium text-slate-900">Vos cookies, vos choix.</div>
            <p className="mt-2 text-xs text-slate-600 leading-relaxed">
              Nous utilisons des cookies strictement nécessaires au fonctionnement du site.
              Aucune donnée n'est partagée à des fins publicitaires sans votre consentement.
              Consultez notre <a className="underline" href="/politique-confidentialite">politique de confidentialité</a>.
            </p>
            <div className="mt-4 flex flex-wrap gap-2">
              <Button
                onClick={() => decide("accepted")}
                data-testid="cookie-accept"
                className="bg-slate-900 hover:bg-slate-800 h-9 px-4 text-xs"
              >
                Tout accepter
              </Button>
              <Button
                onClick={() => decide("essential")}
                data-testid="cookie-essential"
                variant="outline"
                className="h-9 px-4 text-xs border-slate-300"
              >
                Essentiels uniquement
              </Button>
              <Button
                onClick={() => decide("rejected")}
                data-testid="cookie-reject"
                variant="ghost"
                className="h-9 px-4 text-xs"
              >
                Refuser
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
